export const ArrowBottom = () => (
  <path d='M12,17.6c-0.3,0-0.6-0.1-0.8-0.3L2.3,8.3c-0.4-0.4-0.4-1.1,0-1.6s1.1-0.4,1.6,0l8.1,8.1l8.1-8.1c0.4-0.4,1.1-0.4,1.6,0c0.4,0.4,0.4,1.1,0,1.6l-8.9,8.9C12.6,17.4,12.3,17.6,12,17.6z' />
)
